<div class="waec-page-header">
  <img
    class="waec-page-header-image"
    src="{{ headerIcon }}"
    alt="{{ headerIcon }}"
  />
  <h3 class="waec-page-header-text">{{ headerTitle | translate }}</h3>

  <div class="align-left page-header-menu hidden-sm">
    <ul *ngIf="this.user?.type === userTypes.VERIFIER" nz-menu nzMode="horizontal">
      <li nz-menu-item>
        <a class="waec-item" (click)="switchViewfundWallet()"> {{ 'GENERAL.FUND_WALLET' | translate }} </a>
      </li>
      <li nz-menu-item>
        <a class="waec-item" (click)="switchViewtransactionHistory()">
          {{ 'BILLING.BILLING_HISTORY' | translate }}
        </a>
      </li>
    </ul>
  </div>
  <div
    *ngIf="this.user?.type === userTypes.VERIFIER"
    class="align-left page-header-menu visible-sm hidden-pc"
  >
    <div nz-row>
      <div nz-col nzSpan="12">
        <button nz-button nzType="default" (click)="switchViewfundWallet()">
          {{'BILLING.SERVICES' | translate}}
        </button>
      </div>
      <div nz-col nzSpan="12">
        <button
          nz-button
          nzType="default"
          (click)="switchViewtransactionHistory()"
        >
          {{('BILLING.BILLING_HISTORY' | translate) | titlecase}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="page-container" nz-row>
  <div class="verificationaccountBilling">
    <nz-card class="ant-card-body-main" [nzBordered]="false">
      <div nzTitle="Account & Billing">
        <div nz-row class="gutter-row action-pane"></div>

        <div  
          *ngIf="billing_wallet == views.FUNDING" 
          nz-row
          class="fund-wrapper"
        >
          <div 
            nz-col 
            nzXs="24" 
            nzSm="24"
            nzMd="24" 
            nzLg="24" 
            nzXl="14" 
          >
            <div *ngIf="billing_wallet == views.FUNDING">
              <div class="fund">
                <div class="fund-header">
                  <h4 class="header">{{'BILLING.FUNDING_PROMPT' | translate}}</h4>
                  <p class="sub-header">
                   {{ 'BILLING.FUNDING_SUB_PROMPT' | translate }}
                  </p>

                  <div class="form">
                    <nz-form-item>
                      <nz-form-control
                        [nzSm]="24"
                        [nzXs]="24"
                        [nzMd]="18"
                        [nzXl]="14"
                      >
                        <div nz-col>
                          <nz-input-group [nzAddOnAfter]="'BILLING.UNIT_LABEL' | translate">
                            <input
                              appNumbersOnly
                              width="100%"
                              type="number"
                              id="units"
                              nz-input
                              placeholder="{{'BILLING.INPUT_PLACEHOLDER' | translate}}"
                              name="units"
                              [disabled]="!verificationCost"
                              [(ngModel)]="q.units"
                              (ngModelChange)="convertUnit()"
                            />
                          </nz-input-group>
                        </div>
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item
                      nz-row
                      class="register-area"
                    >
                      <nz-form-control
                        [nzSm]="24"
                        [nzXs]="24"
                        [nzMd]="24"
                        [nzLg]="24"
                        [nzXl]="20"
                      >
                        <div nz-row  class="register-area-card" [ngClass]="q.units > 0 ? '' : 'centralize'">
                          <section *ngIf="q.units > 0" nz-row class="row-1">
                            <div 
                              nz-col 
                              [nzSm]="24"
                              [nzXs]="24"
                              [nzMd]="12"
                              [nzLg]="12"
                              [nzXl]="12"
                              class="col-1"
                            >
                              <h5>{{'GENERAL.TRANSACTION_BREAKDOWN' | translate}}</h5>
                              <p>{{'BILLING.BREAKDOWN_DESC' | translate}}</p>
                            </div>

                            <div 
                              nz-col 
                              [nzSm]="24"
                              [nzXs]="24"
                              [nzMd]="12"
                              [nzLg]="12"
                              [nzXl]="12"
                              class="col-2"
                            >
                              <h4>{{ (q.units | number) || 0 }} {{'BILLING.CANDIDATE_S' | translate}}</h4>
                            </div>
                          </section>

                          <section *ngIf="q.units > 0" nz-row [nzJustify]="space-between"  class="row-2">
                            <div nz-col nzSpan="24">
                              <div class="card">
                                <p>{{'BILLING.TOTAL_UNITS' | translate}}</p>
                                <h3>{{( totalUnits | number) || 0}} {{ 'BILLING.UNIT_S' | translate}}</h3>
                              </div>
                            </div>

                            <div nz-row [nzGutter]="{ xs: 0, sm: 0, md: 24, lg: 32 }" class="btn-wrapper">
                              <div 
                                nz-col
                                [nzXs]="24"
                                [nzSm]="24"
                                [nzMd]="24"
                                [nzLg]="24"
                              >
                                <button
                                  nz-button
                                  nzType="primary"
                                  [nzLoading]="loading"
                                  (click)="fundWallet()"
                                  nzSize="small"
                                  nzBlock
                                >
                                  {{'GENERAL.MAKE_PAYMENT' | translate}}
                                </button>
                              </div>

                              <!-- <p 
                                nz-col                                 
                                nzXs="24"
                                nzSm="24"
                                nzMd="24"
                                nzLg="12"
                              >
                                By clicking, you agree to the stated terms and conditions
                              </p> -->
                            </div>
                          </section>

                          <section *ngIf="q.units <= 0"  nz-row class="row-3">
                            <p>
                             {{ 'BILLING.EMPTY_BREAKDOWN' | translate }}
                            </p>
                          </section>
                        </div>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div 
            nz-col  
            nzXs="24" 
            nzSm="24"
            nzMd="24" 
            nzLg="24" 
            nzXl="10"
            nzXXl="8"
            class="service-charge-btn"
            *ngIf="
              !isLocalCountry() ||
              institutionAccountStatus == InstitutionDetailStatus.CREATED
            "
          >   
            <button
              class="card-btn-funding"
              nz-button
              [nzType]="'primary'"
              (click)="displayServiceCharge()"
            >
              <span>{{ 'GENERAL.VIEW_SERVICE_CHARGE' | translate }}</span>
            </button>
          </div>

          <div 
            nz-col  
            nzXs="24" 
            nzSm="24"
            nzMd="24" 
            nzLg="24" 
            nzXl="9"
            nzXXl="9"
            class="reserved-account-wrapper"
            *ngIf="
              institutionAccountStatus !== InstitutionDetailStatus.CREATED && isLocalCountry()
            "
          >
            <div class="reserved-account-content">
              <div 
                nz-col 
                nzXs="24" 
                nzSm="24" 
                nzMd="24" 
                nzLg="24" 
                nzXl="24" 
                class="reserved-account-card"
              >
                <section class="generate-account-wrapper">
                  <div class="generate-account-section-one">
                    <h5>{{ 'GENERAL.ACCOUNT_DETAILS' | translate }}</h5>
                    <small
                      *ngIf="
                        institutionAccountStatus !== InstitutionDetailStatus.PENDING &&
                        institutionAccountStatus !== InstitutionDetailStatus.CREATED
                      "
                    >
                      {{'BILLING.VIRTUAL_ACCOUNT.INIT_MSG' | translate}}
                    </small>

                    <small *ngIf="institutionAccountStatus == InstitutionDetailStatus.PENDING">
                      {{'BILLING.VIRTUAL_ACCOUNT.INIT_MSG' | translate}}
                    </small>
                  </div>

                  <div class="generate-account-section-two">
                    <button
                      class="generate-account-btn"
                      nz-button
                      [nzType]="'primary'"
                      [nzLoading]="isLoading"
                      (click)="onInitiateGenerateAccount()"
                      *ngIf="
                          institutionAccountStatus !== InstitutionDetailStatus.PENDING &&
                          institutionAccountStatus !== InstitutionDetailStatus.CREATED
                        "
                    >
                      <span>{{'BILLING.VIRTUAL_ACCOUNT.GENERATE_BTN' | translate }}</span>
                    </button>

                    <button
                      class="generate-account-btn"
                      nz-button
                      [nzType]="'primary'"
                      [nzLoading]="isLoading"
                      (click)="checkStatus()"
                      *ngIf="institutionAccountStatus === InstitutionDetailStatus.PENDING"
                    >
                      <span>{{'BILLING.VIRTUAL_ACCOUNT.STATUS_BTN' | translate }}</span>
                    </button>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        <div class="transaction-container" *ngIf="billing_wallet == views.HISTORY">
          <nz-row>
            <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="18" nzXl="18">
              <h3 class="waec-card-header-text">
                {{ ("BILLING.BILLING_HISTORY" | translate) | titlecase  }}
              </h3>
              <div class="span-left">
                {{ 'BILLING.HISTORY_SUBTITLE' | translate  }}
              </div>
            </nz-col>
          </nz-row>
          <app-transaction-history></app-transaction-history>
        </div>
      </div>
    </nz-card>
  </div>
</div>

<!-- SERVICE CHARGE MODAL -->
<nz-modal
  [nzStyle]="{ top: '20px' }"
  [nzMask]="true"
  nzMaskClosable="false"
  nzWidth="600px"
  nzClosable="true"
  [(nzVisible)]="viewServiceChargeModal"
  nzTitle="{{'GENERAL.SERVICE_CHARGE' | translate}}"
  [nzContent]="modalServiceCharge"
  [nzFooter]="null"
  (nzOnCancel)="dismissServiceChargeModal()"
>
  <ng-template #modalServiceCharge>
    <!-- <app-billing
      
    ></app-billing> -->
	<p class="modal-desc">{{ serviceChargeModalText | translate}}</p>
	
	<div class="service-charge-modal" *ngIf="user.type == userTypes.USER">
		<p class="item-access">
			<b>{{ 'GENERAL.CERTIFICATE_ACCESS' | translate}}: </b>
			<span>{{ accessCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="accessCost > 0">s</span>
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localAccessCost | number) :"&#36;"+(accessCost | number)
					}})</span>
				</span>
		</p>
		<p class="item-access">
			<b>{{'GENERAL.SHARING_FEE' | translate}}: </b> 
			<span>{{ sharingCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="sharingCost > 0">s</span> 
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localSharingCost | number) :"&#36;"+ (sharingCost | number)
					}})
				</span>
			</span>
		</p>
		<p class="item-access">
			<b>{{'GENERAL.SERVICE_CHARGE_CONFIRM_INT' | translate}}:</b>
			<span> {{ requestConfirmationCost || 0}} {{'GENERAL.UNIT' | translate}}<span *ngIf="requestConfirmationCost > 0">s</span>
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localRequestConfirmationCost | number):"&#36;"+ (requestConfirmationCost | number)
					}})
				</span>
			</span>
		</p>
		<p class="item-access">
			<b>{{'GENERAL.SERVICE_CHARGE_CONFIRM_LOCAL' | translate}}:</b>
			<span> {{ sharingCost || 0}} {{'GENERAL.UNIT' | translate}}<span *ngIf="sharingCost > 0">s</span>
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localSharingCost | number):"&#36;"+ (sharingCost | number)
					}})
				</span>
			</span>
		</p>
		<p class="item-access">
			<b>{{'BILLING.RETRIEVAL_FEE' | translate }}: </b>
			<span>{{retrievalCost || 0}} {{'GENERAL.UNIT' | translate}}<span *ngIf="retrievalCost > 0">s</span> 
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localRetrievalCost | number) :"&#36;"+ (retrievalCost | number)
					}})
				</span>
			</span>
		</p>
	</div>
	<div class="item-container" *ngIf="user.type == userTypes.VERIFIER">
		<p class="item-access">
			<b class="confirmation">{{'GENERAL.CONFIRMATION' | translate}}: </b>
			<span>{{ verificationCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="verificationCost > 0">s</span>
				<span *ngIf="currency"> ({{
					isLocalTransaction() ?
					 userCountry?.symbol+ (localVerificationCost | number ):"&#36;"+ (verificationCost | number)
					}})
				</span>
			</span>
		</p>
	</div>

	<div nz-row>
		<div class="processor-icons " nz-col nzXs="24" nzMd="24">
			<span class="powered-by">{{'GENERAL.POWERED_BY' | translate}}</span> <img class="icons ml-3" src="/assets/icons/payment_processors/flutterwave.svg" alt="">
			<img class="icons paystack ml-3" src="/assets/icons/payment_processors/paystack.svg" alt="">
		</div>
	</div>
  </ng-template>
</nz-modal>

<!-- MODE OF PAYMENT Information -->
<app-payment
  *ngIf="isPaymentOption"
  (closeModal)="cancelPaymentOptionsModal($event)"
  (confirmSubmit)="initiatePayment($event)"
  [action]="'fund-wallet'"
  [Cost]="q.units * verificationCost"
></app-payment>

<!-- VIRTUAL ACCOUNT GENERATION RESULT MODAL -->
<nz-modal
  [nzStyle]="{ top: '100px' }"
  [nzMask]="true"
  nzMaskClosable="false"
  nzWidth="861px"
  nzClosable="true"
  [nzVisible]="isAccountGenerationSuccess"
  [nzContent]="virtualAccountModalContent"
  [nzFooter]="resultModalFooter"
>
  <ng-template #virtualAccountModalContent>

    <nz-result
      class="virtual-result-modal"
      nzStatus=""
      [nzTitle]="virtualAccountResultTitle"
      [nzSubTitle]="virtualAccountResultSubTitle"
    >
      <ng-template #virtualAccountResultTitle let-resultTitle>
        <div nz-row class="virtual-result-title">
          <section nz-col nzSpan="24" class="success-icon-wrapper">
            <svg-icon src="assets/result-check-circle.svg"></svg-icon>
          </section>
          
          <section nz-col nzSpan="24" class="success-title-wrapper">
            <div nz-row nzAlign="middle">
              <svg-icon  nz-col nzMd="2" src="assets/office-building.svg"></svg-icon>
              <h3 nz-col nXs="24" nzSm="24" nzMd="20">{{'BILLING.VIRTUAL_ACCOUNT.SUCCESS_TITLE' | translate}}</h3>
            </div>
          </section>
        </div>
      </ng-template>
  
      <ng-template #virtualAccountResultSubTitle let-resultSubTitle>
        <p class="virtual-result-sub-title">
         {{'BILLING.VIRTUAL_ACCOUNT.SUCCESS_SUB' | translate}}
        </p>
      </ng-template>
  
      <div nz-result-extra class="virtual-result-actions">
        <button nz-button (click)="closeResultModal()">{{('GENERAL.CLOSE' | translate) | titlecase}}</button>
      </div>
    </nz-result>
  </ng-template>
  <ng-template #resultModalFooter> </ng-template>
</nz-modal>

<!-- TRANSACTION SUCCESS MODAL -->
<nz-modal
  [(nzVisible)]="isVisible"
  [nzFooter]="modalFooter"
  [nzContent]="successModalContent"
  [nzMask]="true"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleModalCancel()"
>
  <ng-template #successModalContent>

    <nz-result
      nzStatus="success"
      [nzTitle]="titleSuccessful"
      [nzSubTitle]="description"
    >
      <ng-template #titleSuccessful>
        <h1 class="header" align="center">{{'BILLING.RESULT.SUCCESS' | translate}}</h1>
      </ng-template>
      <ng-template #description>
        <p>{{'GENERAL.TRANSACTION_ID' | translate}}: {{ transaction_details?.reference }}</p>
      </ng-template>
      <div nz-result-extra>
        <button
          nz-button
          nzType="primary"
          (click)="handleModalCancel(); reload()"
        >
          {{'GENERAL.CONTINUE' | translate}}
        </button>
      </div>
    </nz-result>
  </ng-template>
  <ng-template #modalFooter> </ng-template>
</nz-modal>

<!-- TRANSACTION FAILED MODAL -->
<nz-modal
  [nzMask]="true"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  [(nzVisible)]="isVisibleNegative"
  [nzFooter]="modalFooter"
  [nzContent]="failedModalContent"
  (nzOnCancel)="handleModalCancel()"
>
  <ng-template #failedModalContent>

    <nz-result
      nzStatus="error"
      [nzTitle]="titleUnsuccessful"
      [nzSubTitle]="description"
    >
      <ng-template #titleUnsuccessful>
        <h1 class="header" align="center">{{ trxmessage }}</h1>
      </ng-template>
      <ng-template #description>
        <p>{{'GENERAL.TRANSACTION_ID' | translate}}: {{ transaction_details?.reference }}</p>
      </ng-template>
      <div nz-result-extra>
        <button
          nz-button
          nzType="primary"
          (click)="handleModalCancel(); reload()"
        >
          {{'GENERAL.CONTINUE' | translate}}
        </button>
      </div>
    </nz-result>
  </ng-template>
  <ng-template #modalFooter> </ng-template>
</nz-modal>

<!-- VIRTUAL ACCOUNT GENERATION MODAL -->
<digicert-virtual-account-modal 
  *ngIf="isGenerateVirutalAccount"
  [isFormPage]="virtualAccountGenerationInitiated"
  (closeModal)="closeVirtualAccountModal($event)"
  (successResponse)="onConfirmAccountGeneration($event)"
></digicert-virtual-account-modal>


<!-- EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup *ngIf="examCountrySetupModal"
  (closeModal)="closeExamCountrySetupModal()"></app-exam-country-setup>